import { ColumnConfig } from './types'

export function isNumericCellInvalid(value: any): boolean {
  return value != null && value !== '' && isNaN(Number(value))
}

export function isRowValid<T extends Record<string, any>>(
  row: T,
  columns: ColumnConfig<T>[]
): boolean {
  const firstField = columns[0]?.field
  if (!firstField || !row[firstField]) {
    return false
  }

  for (const col of columns) {
    if (col.type === 'number') {
      const value = row[col.field]
      if (isNumericCellInvalid(value)) {
        return false
      }
    }
  }

  return true
}
